
import SvgFileDownloaded from "@/assets/icons/download.svg";
import SvgUpdate from "@/assets/icons/update.svg";
import SelectDesign from "@/components/base/form/SelectDesign.vue";
import DateRange from "@/components/base/pickers/DateRange.vue";
import Search from "@/components/base/Search.vue";
import CurrencyConversion from "@/components/statistics/extended-report/CurrencyConversion.vue";
import ReportFilterByDate from "@/components/statistics/extended-report/ReportFilterByDate.vue";
import { IFilter } from "@/types";
import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
import { useStatsCompareStore } from "../../store_v3/StatsCompareStore";

@Component({
    components: {
        ReportFilterByDate,
        CurrencyConversion,
        SelectDesign,
        DateRange,
        Search,
        SvgFileDownloaded,
        SvgUpdate,
    },
})
export default class ReportLayout extends Vue {
    @Prop({ type: [Number, String], default: 0 }) elevation!: number | string;
    @Prop({ type: String, required: true }) titleReport!: string;
    @Prop({ type: Array, required: true }) filters!: any[];
    @Prop({ type: Boolean, default: false }) readonly isDisabledSubmit!: boolean;
    @Prop({ type: Boolean, default: true }) readonly isSearch!: boolean;
    @Prop({ type: Boolean, default: false }) readonly isCurrencyConversion!: boolean;
    @Prop({ type: Boolean, default: false }) readonly isProgressLoading!: boolean;
    @Prop({ default: 0 }) readonly progress!: number;
    @Prop({ type: Array, default: () => [] }) readonly exportFormats!: [];
    @Prop({ type: Boolean, default: false }) readonly isCompareMode!: boolean;
    @PropSync("settings", { type: Object, required: true }) settingsSync!: {
        loading: boolean;
        searchPlaceholder: string;
        title: string;
        loadingExport: boolean;
        loadingUpdate: boolean;
        convertCurrency: string;
    };
    @Prop({ type: Boolean, default: true }) isShowTitle!: boolean;

    search = "";
    compareStore = useStatsCompareStore();

    get loadingDownloadBtn(): boolean {
        return this.isProgressLoading
            ? this.progress < 100 && this.settingsSync.loadingExport
            : this.settingsSync.loadingExport;
    }

    get groupFilter(): IFilter {
        return this.filters.find((i) => i.id === "group");
    }

    updatePeriod(date: string[]): void {
        this.$emit('change-filters', date);
    }

    updateCompare(): void {
        let currentDate = this.filters[0].select;
        let compareDate = this.filters[1].select;

        if (currentDate.length === 1) {
            currentDate = [currentDate[0], currentDate[0]];
        }
        if (compareDate.length === 1) {
            compareDate = [compareDate[0], compareDate[0]];
        }

        this.compareStore.currentDate = currentDate;
        this.compareStore.compareDate = compareDate;
        this.$emit('change-filters', currentDate);
    }

    updateTable(): void {
        this.settingsSync.loadingUpdate = true;
        this.$emit("update-table");
    }

    selectCurrencyConversion(): void {
        this.$emit("change-cur-conversion");
    }
}
